import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CheckoutCancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-brand-bone flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-2xl border border-border bg-white p-8 md:p-10 shadow-sm text-center" data-testid="checkout-cancelled-card">
        <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto">
          <XCircle className="w-9 h-9 text-destructive" />
        </div>
        <h1 className="font-heading text-2xl font-bold mt-5">Payment cancelled</h1>
        <p className="text-brand-ink/70 mt-2">
          No charge was made. You can restart the audit whenever you're ready.
        </p>
        <Button
          data-testid="cancelled-back-home"
          onClick={() => navigate("/")}
          className="mt-7 rounded-full bg-brand-green hover:bg-brand-greenDark text-white px-8"
        >
          Back to home
        </Button>
      </div>
    </div>
  );
}
